import { useRootStore } from '@nandosaus/state-management';
import { useEffect } from 'react';

import { useFeature } from '@hooks/use-feature';

// Loads catering orders site-wide so the "order in progress" banner can surface a catering delivery
// on its delivery day. loadCateringOrders returns the active (upcoming) orders alongside the past
// ones (same as loadOrders for normal orders), so this is the catering equivalent of the layout's
// useLoadPastOrders. Gated on `show-delivery-tracking` — the banner's own gate — so signed-in users
// only incur the fetch when the banner could actually appear.
const useLoadActiveCateringOrders = () => {
  const { MemberStore, PastOrdersStore } = useRootStore();
  const showDeliveryTracking = useFeature('show-delivery-tracking');

  useEffect(() => {
    if (MemberStore.isSignedIn && showDeliveryTracking) {
      PastOrdersStore.loadCateringOrders();
    }
  }, [MemberStore.isSignedIn, showDeliveryTracking, PastOrdersStore]);
};

export { useLoadActiveCateringOrders };
